import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Text } from '@nerdwallet/currency';
import StructuredContent from '@nerdwallet/structured-content';
import { stringInputSpec, stringSelectSpec } from '../../lib/editing-configs';

let iframe = null;
let marketPlaceIframeMonitor = null;

const MarketplaceThirdPartyEmbedWrapper = ({ id, alignment }) => {
  useEffect(() => {
    if (!iframe && id) {
      marketPlaceIframeMonitor = setInterval(() => {
        if (iframe) {
          clearInterval(marketPlaceIframeMonitor);
        } else {
          iframe = document.querySelector(
            `iframe[title="Marketplace Embed ${id}"]`
          );
          iframe.contentDocument.body.style.textAlign = alignment;
          iframe = null;
        }
      }, 300);
    }
    return () => clearInterval(marketPlaceIframeMonitor);
  }, [id, alignment]);

  if (!id) {
    return (
      <Box justifyContent="center" display="flex">
        <Text
          size="large"
          bold
          align="center"
          className="marketplace-third-party-no-content"
        >
          Enter a valid MarketPlace ID to make it appear
        </Text>
      </Box>
    );
  }

  return (
    <Box id="marketplace-wrapper" alignContent="center">
      <StructuredContent>
        {{
          type: 'Container',
          version: '1.0.0',
          props: {
            children: {
              type: 'MarketplaceThirdPartyEmbed',
              version: '1.0.0',
              props: {
                id,
              },
            },
          },
        }}
      </StructuredContent>
    </Box>
  );
};

MarketplaceThirdPartyEmbedWrapper.propTypes = {
  /**
   * The ID of the Marketplace Product entity representing the Embed.
   */
  id: PropTypes.string.isRequired,
  alignment: PropTypes.string,
};

MarketplaceThirdPartyEmbedWrapper.defaultProps = {
  id: '',
  alignment: 'left',
};

MarketplaceThirdPartyEmbedWrapper.getEditingConfig = () => {
  return [
    stringInputSpec('id', 'MarketPlace ID'),
    stringSelectSpec('alignment', 'Alignment Layout', [
      { label: 'Left', value: 'left' },
      { label: 'Center', value: 'center' },
      { label: 'Right', value: 'right' },
    ]),
  ];
};

MarketplaceThirdPartyEmbedWrapper.displayName =
  'MarketplaceThirdPartyEmbedWrapper';

export default MarketplaceThirdPartyEmbedWrapper;
